module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "layout-copy"
  }, [_c('p', [_vm._v("2017-2020 © QU BOPS")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ccd39590","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/CommonFooter.vue
// module id = 1974
// module chunks = 8